import { render, staticRenderFns } from "./ModuleForm.vue?vue&type=template&id=3286991e&scoped=true&"
import script from "./ModuleForm.vue?vue&type=script&lang=js&"
export * from "./ModuleForm.vue?vue&type=script&lang=js&"
import style0 from "./ModuleForm.vue?vue&type=style&index=0&id=3286991e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3286991e",
  null
  
)

export default component.exports